import { Routes,Route } from "react-router-dom";
import JuegosOferta from './components/juegosOferta.jsx';
import Home  from './components/home.jsx';
import UsuariosAdmin from './components/administration/usuariosAdmin/usuariosAdmin.jsx';
import JuegosAdmin from './components/administration/juegosAdmin/juegosAdmin.jsx';
import ReventasAdmin from './components/administration/reventasAdmin/reventasAdmin.jsx';
import SolicitudesAdmin from './components/administration/solicitudesAdmin/solicitudesAdmin.jsx'
import Cuentas from './components/administration/cuentasAdmin/cuentasAdmin.jsx'
import Registro from './components/registro.jsx'
import Activa from './components/activa.jsx'
import ClientDashboard from "./components/clientDashboard/clientDashboard.jsx"
import GameCards from "./components/clientDashboard/gameCards.jsx"
import ReventasClient from "./components/clientDashboard/reventasClient.jsx"
import ReventasPublicadas from "./components/administration//reventasAdmin/reventasPublicadas.jsx"
import JuegosCliente from "./components/administration//reventasAdmin/juegosCliente.jsx"


function App() {
  return (
    
      <Routes>
        <Route  path="/" element={ <JuegosOferta/> } />
        <Route path="/dashboard" element={ <ClientDashboard /> } >
          <Route path="juegos" element={<GameCards/>}/>
          <Route path="reventas" element={<ReventasClient/>}/>
        </Route>
        <Route  path="/registro" element={ <Registro/> } /> 
        <Route  path="/activa/:id" element={ <Activa/> } /> 

        <Route  path="/home" element={ <Home/> } >
          <Route  path="juegos" element={ <JuegosAdmin/> } />
          <Route  path="cuentas" element={ <Cuentas/> } />

          <Route  path="reventas" element={ <ReventasAdmin/> } >
            <Route path="reventasPublicadas" element={<ReventasPublicadas/>} />
            <Route path="juegosCliente" element={<JuegosCliente/>} />
          </Route>
          <Route  path="usuarios" element={ <UsuariosAdmin/> } />
          <Route  path="solicitudes" element={ <SolicitudesAdmin/> } />
        </Route>
        
        
      </Routes>
    
   
  );
}

export default App;
